"use client";

import { usePathname } from "next/navigation";
import { Footer } from "./Footer";

export function FooterGate() {
  const pathname = usePathname();

  if (!pathname) return null;
  const protectedPrefixes = [
    "/chat",
    "/brand-search",
    "/thread-page",
    "/facebook-page",
    "/account",
  ];

  const isProtectedRoute = protectedPrefixes.some((prefix) =>
    pathname.startsWith(prefix)
  );
  const isPortfolioPublicView = pathname.startsWith("/portfolio/");

  if (isProtectedRoute && !isPortfolioPublicView) {
    return null;
  }

  return <Footer />;
}


